import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  CardTitle,
  CardBody,
  Row,
  Button,
  Collapse,
  Table,
  Spinner,
} from "reactstrap";
// componentes
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import SearchFilters from "../../../components/SearchFilters";
import Pagination from "../../../components/Paginationv3";
import WaitExport from "../../../components/WaitExport";
import DeleteButton from "../../../components/Buttons/DeleteButton";
import ActionButtonRounded from "../../../components/Buttons/ActionButtonRounded";
import ModalConfirmDeleteAll from "../../../components/ModalConfirmDeleteAll";
// utils e service
import {
  deleteAll,
  deleteScheduling,
  getScheduling,
} from "../../../utils/services/scheduling";
import useDebounce from "../../../utils/hooks/useDebounce";
// redux
import { useLocation } from "react-router-dom";
// exportar
import { createXlsx } from "./createXlsx";
import { ModalNewScheduling } from "./ModalNewScheduling";
import { connect } from "react-redux";
import { getParticipantsLogistic } from "../../../utils/services/participants";
import SweetAlert from "react-bootstrap-sweetalert";
import LoadingSkelentonTable from "../../../components/loadingSkeletonTable";
import { toast } from "react-toastify";

function SchedulingReport(props) {
  const location = useLocation();
  const eventId = location.state.idEvent;
  const token = props.state.global_user_data.data.token;
  const participants = useRef(null);

  // const eventId = "f2beb642-45c3-4ada-abb6-ca3c6688e369";
  // export in progress
  const [exportInProgress, setExportInProgress] = useState(false);
  const [finishExport, setFinishExport] = useState(false);
  // listagem
  const [list, setList] = useState([]);
  // pesquisa
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 300);
  // collapse state
  const [isOpen, setIsOpen] = useState(false);
  const [modalNewScheduling, setModalNewScheduling] = useState(false);
  const [collapseIsOpen, setCollapseIsOpen] = useState(false);
  const [modalDeleteAll, setModalDeleteAll] = useState(false);
  // paginacao
  const [currentIndex, setCurrentIndex] = useState(1);
  const [countData, setCountData] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [dynamic_title, setdynamic_title] = useState("");
  const [dynamic_description, setdynamic_description] = useState("");
  const [success_dlg, setsuccess_dlg] = useState(false);
  const [errorOnDeleteAll, setErrorOnDeleteAll] = useState(false);
  // exibir botão deletar todos
  const [showDeleteAll, setShowDeleteAll] = useState(false);
  // filtro
  const [activeFilter, setActiveFilter] = useState("participantName");
  const columnsFilter = [
    { name: "Participante", value: "participantName", type: "text" },
    { name: "Atividade", value: "atividade", type: "text" },
    { name: "Data", value: "dataHoraInicio", type: "date" },
    { name: "Tipo", value: "tipo", type: "text" },
  ];

  const [loading, setLoading] = useState(false);
  const [deleteConfirmAlert, setDeleteConfirmAlert] = useState(false);
  const [successAlert, setSuccessAlert] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  function setActiveFilterHandle(columnActive) {
    setActiveFilter(columnActive);
    setSearch("");
  }

  function formatDateTime(data) {
    const datePart = data.split("T");
    return `${formatDate(datePart[0])} ${datePart[1].substring(0, 5)}`;
  }

  function formatDate(date) {
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`;
  }

  function getList() {
    setLoading(true);
    getScheduling({
      eventId: eventId,
      offset: currentIndex,
      limit: itemsPerPage,
      search: debouncedSearch,
      columnSearch: activeFilter,
    })
      .then((res) => {
        setCountData(res.total);
        setList(res.data);
      })
      .catch((error) => {
        console.error("Erro ao buscar agendamentos:", error);
        toast.error("Erro ao buscar agendamentos.");
      })
      .finally(() => setLoading(false));
  }

  // busca os participantes do evento para alimentar o modal de criar agendamento
  useEffect(() => {
    async function fetchParticipants() {
      try {
        const partForm = await getParticipantsLogistic({
          idEvent: eventId,
          offset: 0,
          limit: 0,
          search: "",
        });

        participants.current = partForm?.data?.data;
      } catch (error) {
        console.error("Erro ao buscar participantes:", error);
        toast.error("Erro ao buscar os participantes.");
      }
    }

    fetchParticipants();
  }, [eventId]);

  async function confirmDeleteAll() {
    setLoadingDelete(true);
    try {
      const response = await deleteAll(eventId);
      if (response.message === "deleted") {
        setdynamic_title("Sucesso");
        setdynamic_description("Agendamentos deletados com sucesso");
        setErrorOnDeleteAll(false);
      } else {
        setdynamic_title("Erro");
        setdynamic_description("Ocorreu um erro ao deletar os Agendamentos");
        setErrorOnDeleteAll(true);
      }
      setsuccess_dlg(true);
      getList();
    } catch (error) {
      console.error("Erro ao deletar os agendamentos:", error);
      setdynamic_title("Erro");
      setdynamic_description("Erro ao deletar os agendamentos.");
      setErrorOnDeleteAll(true);
      setsuccess_dlg(true);
    } finally {
      setLoadingDelete(false);
    }
  }

  useEffect(() => {
    getList();
  }, [debouncedSearch, itemsPerPage, currentIndex]);

  const handleDeleteClick = (id) => {
    setSelectedId(id);
    setDeleteConfirmAlert(true);
  };

  // dispara a geração do xlsx e mostra o indicador de exportação em progresso
  function handleExportReport() {
    createXlsx({
      eventId: eventId,
      limit: 10000,
      search: debouncedSearch,
      columnSearch: activeFilter,
      countData,
      setFinishExport,
    });
    setExportInProgress(true);
  }

  const confirmDelete = () => {
    deleteScheduling(selectedId, token)
      .then(() => {
        setSuccessAlert(true);
        setDeleteConfirmAlert(false);
        getList();
      })
      .catch((error) => {
        console.error("Erro ao excluir agendamento", error);
        setDeleteConfirmAlert(false);
      });
  };

  return (
    <>
      {modalDeleteAll && (
        <ModalConfirmDeleteAll
          isOpen={modalDeleteAll}
          toggle={() => setModalDeleteAll(false)}
          title="Deletar Agendamentos"
          onConfirm={confirmDeleteAll}
        />
      )}

      {exportInProgress && (
        <WaitExport
          isOpen={exportInProgress}
          name="Agendamentos"
          preposicao="dos"
          finishExport={finishExport}
          setFinishExport={setFinishExport}
          setExportInProgress={setExportInProgress}
        />
      )}

      {modalNewScheduling && (
        <ModalNewScheduling
          isOpen={modalNewScheduling}
          toggle={() => setModalNewScheduling(false)}
          idEvent={eventId}
          participants={participants?.current}
          token={token}
          refetch={getList}
          list={list}
        />
      )}

      <SweetAlert
        warning
        showCancel
        show={deleteConfirmAlert}
        title="Deseja deletar esse agendamento?"
        confirmBtnText="Sim"
        cancelBtnText="Não"
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="secondary"
        onConfirm={confirmDelete}
        onCancel={() => setDeleteConfirmAlert(false)}
      >
        Você não poderá reverter essa ação.
      </SweetAlert>

      <SweetAlert
        success
        show={successAlert}
        title="Sucesso"
        confirmBtnText="OK"
        onConfirm={() => {
          setSuccessAlert(false);
          setDeleteConfirmAlert(false);
        }}
      >
        Agendamento deletado com sucesso
      </SweetAlert>
      {success_dlg ? (
        <SweetAlert
          success={!errorOnDeleteAll}
          error={errorOnDeleteAll}
          title={dynamic_title}
          onConfirm={() => {
            setsuccess_dlg(false);
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        >
          <>
            <p>{dynamic_description}</p>
          </>
        </SweetAlert>
      ) : null}

      <Card>
        <CardBody>
          <CardTitle>Relatório de Agendamentos</CardTitle>

          <div>
            <Row
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 10,
                width: "50px",
              }}
            >
              <SectionComponent
                sectionName="Filtros"
                setIsOpen={setCollapseIsOpen}
                isOpen={collapseIsOpen}
              />
            </Row>
            <Collapse isOpen={collapseIsOpen}>
              <SearchFilters
                columns={columnsFilter}
                activeFilter={activeFilter}
                setActiveFilterHandle={setActiveFilterHandle}
              />
            </Collapse>
          </div>

          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              marginBottom: 10,
            }}
          >
            <form
              className="app-search d-none d-lg-block events-input-search"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="position-relative">
                <input
                  value={search}
                  type={activeFilter === "dataHoraInicio" ? "date" : "text"}
                  className="form-control"
                  placeholder="Pesquisar..."
                  onChange={(e) => setSearch(e.target.value)}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>

            <div className="mobile-btn-section" style={{ width: "100%" }}>
              <Row className="mobile-btns-top">
                <form
                  className="app-search"
                  style={{ padding: "0px" }}
                  onSubmit={(e) => e.preventDefault()}
                >
                  <div className="position-relative">
                    <input
                      type="text"
                      value={search}
                      className="form-control"
                      placeholder="Pesquisar..."
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <span className="bx bx-search-alt" />
                  </div>
                </form>
              </Row>

              {countData > 0 && (
                <>
                  <SectionComponent
                    sectionName="Opções"
                    setIsOpen={setIsOpen}
                    isOpen={isOpen}
                  />

                  <Collapse isOpen={isOpen}>
                    <ActionButtonRounded
                      title="Exportar Relatório"
                      onClick={handleExportReport}
                      type="mobile"
                    />
                    <ActionButtonRounded
                      title="Criar Agendamento"
                      onClick={() => setModalNewScheduling(true)}
                      type="mobile"
                    />
                  </Collapse>
                </>
              )}
            </div>

            <div className="header-btns-container">
              {countData > 0 && (
                <Button
                  color="success"
                  className="btn-rounded waves-effect waves-light events-button-add-lg"
                  onClick={handleExportReport}
                >
                  Exportar Relatório
                </Button>
              )}

              <ActionButtonRounded
                title="Criar Agendamento"
                className="btn-rounded waves-effect waves-light events-button-add-lg"
                onClick={() => setModalNewScheduling(true)}
                margin={"0 0 0 5px"}
              />
            </div>
          </div>

          <div className="table-responsive">
            <Table className="table mb-0">
              <thead className="table-light">
                <tr>
                  <th>ID do Participante</th>
                  <th>Nome do Participante</th>
                  <th>Sala</th>
                  <th>Atividade</th>
                  <th>Data e Hora Início</th>
                  <th>Data e Hora Fim</th>
                  <th>Tipo</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <LoadingSkelentonTable lines={itemsPerPage} cols={8} />
                ) : (
                  list.length > 0 &&
                  list.map((item, index) => (
                    <tr key={index}>
                      <td>{item.participantId}</td>
                      <td>{item.participantName}</td>
                      <td>{item.sala}</td>
                      <td>{item.atividade}</td>
                      <td>{formatDateTime(item.dataHoraInicio)}</td>
                      <td>{formatDateTime(item.dataHoraFim)}</td>
                      <td>{item?.tipo}</td>
                      <td style={{ textAlign: "center" }}>
                        <DeleteButton
                          onClick={() => handleDeleteClick(item.id)}
                          color="red"
                          fontSize={17}
                        />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>

      <div
        className="bottom-navigation"
        style={{
          justifyContent: `${list?.length > 0 && showDeleteAll ? "space-between" : "end"}`,
        }}
      >
        {list?.length > 0 && (
          <>
            {loadingDelete && <Spinner size="sm" className="me-2" />}
            <ActionButtonRounded
              onClick={() => setModalDeleteAll(true)}
              title="Limpar Todos Agendamentos"
              action="D"
              color="danger"
              setShow={setShowDeleteAll}
              verifyShow={true}
              className="btn-rounded waves-effect waves-light events-button-add-lg"
            />
          </>
        )}

        <Pagination
          data={list}
          search={search}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          countData={countData}
          maxItemPerPage={itemsPerPage}
          setMaxItemPerPage={setItemsPerPage}
          maxPageButtonsToShow={3}
        />
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  state: state,
});

export default connect(mapStateToProps)(SchedulingReport);
